// Wait for ModalDialog to be defined before creating EventModal
if (typeof ModalDialog === 'undefined') {
  // If ModalDialog isn't loaded yet, wait for it
  document.addEventListener('DOMContentLoaded', defineEventModal);
} else {
  defineEventModal();
}

function defineEventModal() {
  if (!customElements.get('event-modal') && typeof ModalDialog !== 'undefined') {
    customElements.define(
      'event-modal',
      class EventModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.initNavigation();
      }

      initNavigation() {
        // Add keyboard navigation for arrow keys
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            this.navigate(-1);
          } else if (event.key === 'ArrowRight') {
            this.navigate(1);
          }
        });

        // Touch/swipe support
        let touchStartX = 0;
        let touchEndX = 0;

        this.addEventListener('touchstart', (e) => {
          touchStartX = e.changedTouches[0].screenX;
        });

        this.addEventListener('touchend', (e) => {
          touchEndX = e.changedTouches[0].screenX;
          this.handleSwipe();
        });

        const handleSwipe = () => {
          if (touchEndX < touchStartX - 50) {
            // Swipe left - next image
            this.navigate(1);
          }
          if (touchEndX > touchStartX + 50) {
            // Swipe right - previous image
            this.navigate(-1);
          }
        };
        this.handleSwipe = handleSwipe;
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaItems = this.querySelectorAll('[data-media-id]');
        
        // Find current index
        const currentMediaId = this.openedBy.getAttribute('data-media-id');
        mediaItems.forEach((element, index) => {
          if (element.getAttribute('data-media-id') === currentMediaId) {
            this.currentIndex = index;
            element.classList.add('active');
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            element.classList.remove('active');
          }
        });

        // Update navigation button states
        this.updateNavigationButtons();
      }

      navigate(direction) {
        const mediaItems = this.querySelectorAll('[data-media-id]');
        if (mediaItems.length === 0) return;

        // Calculate new index
        this.currentIndex += direction;
        
        // Loop around if needed
        if (this.currentIndex < 0) {
          this.currentIndex = mediaItems.length - 1;
        } else if (this.currentIndex >= mediaItems.length) {
          this.currentIndex = 0;
        }

        // Show the new active media
        mediaItems.forEach((element, index) => {
          if (index === this.currentIndex) {
            element.classList.add('active');
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            element.classList.remove('active');
          }
        });

        this.updateNavigationButtons();
      }

      updateNavigationButtons() {
        const mediaItems = this.querySelectorAll('[data-media-id]');
        const prevButton = this.querySelector('.event-modal__nav--prev');
        const nextButton = this.querySelector('.event-modal__nav--next');

        if (prevButton && nextButton) {
          // Show/hide based on position (or always show if looping)
          prevButton.style.display = 'flex';
          nextButton.style.display = 'flex';
        }
      }
    }
    );
  }
}
